import { useRef } from 'react'
import axios from '@fs/zion-axios'
/*
import requestReducer, { initialState } from './requestReducer'
import { fetching, success, error } from './actionCreators'
import { error } from './actionCreators'
*/
import endpoints from './endpoints'

const useApiRequestor = (endpointName, { pathVars = null, queryStringVars = null }) => {
  // const [state, dispatch] = useReducer(requestReducer, initialState)
  const madeRequest = useRef(false)
  const getEndpoint = (epName, args) => {
    const endpoint = endpoints[epName]
    const interpolatedEndpoint = { ...endpoint }
    if (args) {
      Object.keys(args).forEach((key) => {
        interpolatedEndpoint.url = interpolatedEndpoint.url.replace(`{${key}}`, args[key])
      })
      // TO DO:  Warn if replacement key wasn't found in url to interpolate
    }

    return interpolatedEndpoint
  }
  const source = axios.CancelToken.source()
  const token = source.token
  const makeRequest = async ({ successCB, failureCB, data, pathVariables, queryStringVariables, repeatable }) => {
    let response
    if (!madeRequest.current || repeatable) {
      madeRequest.current = true
      const verb = endpointName.split('_')[0]
      // Convention is the first part of the name is the verb, ie: GET_FAMILY verb = 'get'
      // dispatch(fetching())
      try {
        const pv = pathVars ? { ...pathVars, pathVariables } : pathVariables
        const qv = queryStringVars ? { ...queryStringVars, queryStringVariables } : queryStringVariables
        const endpoint = getEndpoint(endpointName, pv)

        if (verb === 'get') {
          response = await axios.get(endpoint.url, { params: qv, cancelToken: token })
        } else {
          response = await axios[verb](endpoint.url, data, { params: qv, cancelToken: token })
        }
        if (successCB) {
          successCB(response)
        }
        // dispatch(success(response))
      } catch (e) {
        // TO DO:  Log the error
        if (failureCB) {
          failureCB(e)
        }
        // dispatch(error(e))
      }
    }
  }

  return [makeRequest, source]
}

export default useApiRequestor
